module.exports = __webpack_public_path__ + "img/fukushima.1271a1de.png";